import React, { Children, useState } from 'react';
import { Cell, Grid } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import classnames from 'classnames';

import './VerticalTabSection.module.css';

const VerticalTabSection = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = Children.map(children, child => child.props);

  return (
    <Grid direction="x" hasContainer>
      <Cell mediumSize={6}>
        {children.map((child, i) => {
          return (
            <button
              styleName={classnames('selector', { selected: activeTab === i })}
              onClick={() => setActiveTab(i)}
              key={child.props.title}
            >
              <Header level={4} displayAs={5}>
                {child.props.title}
              </Header>
            </button>
          );
        })}
      </Cell>
      <Cell mediumSize={18}>{children[activeTab]}</Cell>
    </Grid>
  );
};
const VerticalTab = ({ title, children }) => {
  return <div>{children}</div>;
};

export { VerticalTabSection, VerticalTab };
